import React from 'react';
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import './IngestSessionInfo.scss';

const moment = extendMoment(Moment as any);

export interface SessionData {
    title: string;
    provider: string;
    status: string;
    startTime: string;
    contentType: string;
    partnerName: string;
}

export interface IngestSessionInfoProps {
    sessionData: SessionData;
    textEnums?: {
        feedProviders: {[key: string]: string};
        feedItemStatuses: {[key: string]: string};
    };
}

export const IngestSessionInfo = (props: IngestSessionInfoProps) => {
    const {sessionData, textEnums} = props;
    const {title, provider, status, startTime, contentType, partnerName} = sessionData;
    const feedProviders = textEnums?.feedProviders;
    const feedItemStatuses = textEnums?.feedItemStatuses;
    const date = moment(startTime).format('YYYY-MM-DD');
    const time = moment(startTime).format('HH:mm');

    return (
        <div className="ingest-session-info">
            <div className="ingest-session-info__header">Ingest Session Error</div>
            <div className="ingest-session-info__content">
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">Title:</div>
                    <div className="ingest-session-info__item_data">{title}</div>
                </div>
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">Failure Reason:</div>
                    <div className="ingest-session-info__item_data failure-reason">
                        {feedItemStatuses?.[status]}
                    </div>
                </div>
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">Date:</div>
                    <div className="ingest-session-info__item_data">
                        {date} at {time}
                    </div>
                </div>
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">Provider:</div>
                    <div className="ingest-session-info__item_data">
                        {feedProviders?.[provider]}
                    </div>
                </div>
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">
                        Content Partner:
                    </div>
                    <div className="ingest-session-info__item_data">{partnerName}</div>
                </div>
                <div className="ingest-session-info__item">
                    <div className="ingest-session-info__item_label">Content Type:</div>
                    <div className="ingest-session-info__item_data">{contentType}</div>
                </div>
            </div>
        </div>
    );
};
